import { render, staticRenderFns } from "./TimelineAvatar.vue?vue&type=template&id=31d2cc7b&scoped=true"
import script from "./TimelineAvatar.vue?vue&type=script&lang=js"
export * from "./TimelineAvatar.vue?vue&type=script&lang=js"
import style0 from "./TimelineAvatar.vue?vue&type=style&index=0&id=31d2cc7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d2cc7b",
  null
  
)

export default component.exports